// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-content {
  display: grid;
  gap: 20px 10px;
}

.mat-dialog-content-fix {
  padding-top: 20px;
}

.setters-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/table-editor-dialog-box/table-editor-dialog-box.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AACF","sourcesContent":[".grid-content {\n  display: grid;\n  gap: 20px 10px;\n}\n\n.mat-dialog-content-fix {\n  padding-top: 20px;\n}\n\n.setters-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  padding-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
